<app-dialog-heading [heading]="'Bank Account Verification'"></app-dialog-heading>

<form [formGroup]="verificationForm">
  <!-- ID Number and ID Type -->
  <div class="clearfix mb2">
    <div class="col col-6 pr2">
      <app-element-input
        [label]="'ID Number'"
        [required]="true"
        [customValidators]="[CustomValidator.idNumberNumeric, CustomValidator.idNumberLength, CustomValidator.idNumberDOB, CustomValidator.idLuhnValidation]"
        [customErrorMessages]="idNumberErrorMessage"
        [formControlName]="controls.IdNumber"
        [cssClasses]="['w-100']">
      </app-element-input>
    </div>
    <div class="col col-6">
      <app-element-select
        [displayLabel]="'ID Type'"
        [required]="true"
        [emitNameValueDTO]="true"
        [options]="idTypeOptions"
        [formControlName]="controls.IdType"
        (selectionChanged)="onSelectionIDTypeChange($event)">
      </app-element-select>
    </div>
  </div>

  <!-- Bank Name and Branch Code -->
  <div class="clearfix mb2">
    <div class="col col-6 pr2">
      <app-element-select
        [displayLabel]="'Bank Name'"
        [required]="true"
        [emitNameValueDTO]="true"
        [options]="bankCodeOptions"
        [formControlName]="controls.BankCode"
        (selectionChanged)="onSelectionBankChange($event)">
      </app-element-select>
    </div>
    <div class="col col-6">
      <app-element-input
        [label]="'Branch Code'"
        [required]="true"
        [formControlName]="controls.BranchCode"
        [customValidators]="[CustomValidator.SABranchCodeValidator]"
        [customErrorMessages]="{
          'branchCodeNumeric': 'Branch code must contain exactly 6 numeric digits.'
        }"
        [cssClasses]="['w-100']">
      </app-element-input>
    </div>
  </div>

  <!-- Account Type and Account Number -->
  <div class="clearfix mb2">
    <div class="col col-6 pr2">
      <app-element-input
        [label]="'Account Type'"
        [formControlName]="controls.AccountType"
        [cssClasses]="['w-100']">
      </app-element-input>
    </div>
    <div class="col col-6">
      <app-element-input
        [label]="'Account Number'"
        [required]="true"
        [formControlName]="controls.AccountNumber"
        [customValidators]="[CustomValidator.idNumberNumeric]"
        [customErrorMessages]="{
          'idNumberNumeric': 'Account Number can only contain numbers.'
        }"
        [cssClasses]="['w-100']">
      </app-element-input>
    </div>
  </div>

  <!-- Initials and Surname -->
  <div class="clearfix mb2">
    <div class="col col-6 pr2">
      <app-element-input
        [label]="'Initials'"
        [required]="true"
        [formControlName]="controls.Initials"
        [cssClasses]="['w-100']">
      </app-element-input>
    </div>
    <div class="col col-6">
      <app-element-input
        [label]="'Surname'"
        [required]="true"
        [formControlName]="controls.Surname"
        [cssClasses]="['w-100']">
      </app-element-input>
    </div>
  </div>
</form>
<!-- Verification Results -->
<div *ngIf="verificationResponse" class="mt3">
  <mat-card>
    <mat-card-content>
      <div class="property-grid">
        <div *ngFor="let property of verificationDisplayProperties">
          <div class="bold">{{property.name}}</div>
          <div class="flex items-center">
            <greydom-status-indicator
              *ngIf="property.showIndicator"
              [fillColor]="getStatusColor(property.status)"
              class="mr1">
            </greydom-status-indicator>
            <span>{{property.value}}</span>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>

<mat-dialog-actions align="center" class="flex">
  <button class="mr2"
          mat-raised-button
          color="warn"
          (click)="onClose()">
    Close
  </button>
  <button mat-raised-button
          color="primary"
          [disabled]="!verificationForm.valid"
          (click)="onVerify()">
    Verify
  </button>
</mat-dialog-actions>
